import React, { useState } from 'react';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Box, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import { Link, useNavigate } from "react-router-dom";
import Routes from '../../Routes';
import Footer from './Footer';

const drawerWidth = 180;

const useStyles = makeStyles({
    drawerPaper: {
        width: drawerWidth,
        backgroundColor: '#050035 !important',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
    },
    menuList: {
        flexGrow: 1,
        paddingTop: 16,
    },
    listItem: {
        color: '#fff',
        opacity: 0.7,
        transition: 'opacity 0.3s ease, transform 0.3s ease',
        '&:hover': {
            opacity: 1,
            transform: 'scale(1.05)',
        },
    },
    activeListItem: {
        color: '#fff',
        opacity: 1,
        transform: 'scale(1.05)',
        transition: 'opacity 0.3s ease',
        '&:hover': {
            opacity: 1,
        },
    },
    listItemIcon: {
        color: '#fff !important',
    },
    footer: {
        marginTop: 'auto',
    },
});

const MobileSideBar = ({ open, onClose }) => {
    const classes = useStyles();
    const [activeMenuItem, setActiveMenuItem] = useState(1);
    const userRole = localStorage.getItem("userRole");
    const navigate = useNavigate();

    const handleMenuItemClick = (index, path) => {
        setActiveMenuItem(index);
        onClose();
        navigate(path);
    };

    return (
        <Drawer
            classes={{ paper: classes.drawerPaper }}
            variant="temporary"
            open={open}
            onClose={onClose}
            sx={{
                display: { xs: 'block', md: 'none' },
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '8px' }}>
                <IconButton
                    color="inherit"
                    aria-label="close drawer"
                    edge="end"
                    onClick={onClose}
                >
                    <CloseIcon style={{ color: '#fff' }} />
                </IconButton>
            </Box>
            <List className={classes.menuList}>
                {Routes.mainRoutes.map((item, index) => (
                    item.icon && (
                        ((item.name === "User Management" || item.name === "Data Management" || item.name === "Team Activities") ? userRole === "Mentor" &&
                            <ListItem
                                key={item.name}
                                className={`${classes.listItem} ${index === activeMenuItem && classes.activeListItem}`}
                                component={Link}
                                to={item.path}
                                onClick={() => handleMenuItemClick(index, item.path)}
                            >
                                <ListItemIcon className={classes.listItemIcon}>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText
                                    primary={item.name}
                                    primaryTypographyProps={{ style: { fontSize: '12px' } }}
                                />
                            </ListItem>
                            :
                            <ListItem
                                key={item.name}
                                className={`${classes.listItem} ${index === activeMenuItem && classes.activeListItem}`}
                                component={Link}
                                to={item.path}
                                onClick={() => handleMenuItemClick(index, item.path)}
                            >
                                <ListItemIcon className={classes.listItemIcon}>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText
                                    primary={item.name}
                                    primaryTypographyProps={{ style: { fontSize: '12px' } }}
                                />
                            </ListItem>
                        ))
                ))}
            </List>
            <Footer className={classes.footer} />
        </Drawer>
    );
};

export default MobileSideBar;
